import { render } from "./TvmLoaderModal.vue?vue&type=template&id=e41d2e16"
import script from "./TvmLoaderModal.vue?vue&type=script&lang=js"
export * from "./TvmLoaderModal.vue?vue&type=script&lang=js"

import "./TvmLoaderModal.vue?vue&type=style&index=0&id=e41d2e16&lang=css"

import exportComponent from "../../../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/shared/ChatWidget/TvmLoaderModal/TvmLoaderModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e41d2e16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e41d2e16', __exports__)) {
    api.reload('e41d2e16', __exports__)
  }
  
  module.hot.accept("./TvmLoaderModal.vue?vue&type=template&id=e41d2e16", () => {
    api.rerender('e41d2e16', render)
  })

}


export default __exports__